import { Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateWebsiteVisibility = generateAPI<
  { body: { websiteDisabled: boolean } },
  Wedding
>("put", "wedding/website-visibility", "wedding/");
